import React, { useEffect } from "react";
import "./LoadingScreen.css";

function LoadingScreen({ style, h1 }) {
  useEffect(() => {
    const body = document.getElementsByTagName("body")?.[0];
    body.style.overflow = "hidden";

    return () => {
      body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="loading-screen" style={{ ...style }}>
      <div className="spinner" />
      {h1 && <p>{h1}</p>}
    </div>
  );
}

export default LoadingScreen;
